import { Fragment } from "react";
import { Card, Col, Row } from "react-bootstrap";

export default function Banner() {
    return (
        <Fragment>
            <Row>
                <Col>
                    The American Board of Psychiatry and Neurology, Inc. (ABPN) is a not-for-profit corporation dedicated to supporting high quality psychiatric and neurologic care for the public. The ABPN develops, promotes, and advances programs of excellence, efficiency, integrity, and fairness for candidates and diplomates, and effective training and lifelong learning for psychiatrists and neurologists. The ABPN is a Member Board of the American Board of Medical Specialties (ABMS).
                </Col>
            </Row>
            <Row className="h-100 mt-4 mb-3">
                <Col>
                    <Card className="border-3 border-secondary h-100">
                        <div className="d-flex justify-content-center mt-n4"><div className="text-secondary bg-white p-2 fw-bold">Board Certification</div></div>
                        <Card.Body className="pt-0">
                            <Card.Text>
                                The American Board of Medical Specialties (ABMS) works in collaboration with 24 specialty member boards (including the ABPN) to maintain the standards for physician board certification. The ABMS also provides a comprehensive website — <a className="link-primary" target="_blank" rel="noreferrer" href="https://www.certificationmatters.org/">Certification Matters</a> — as a resource for the public to learn more about board certification.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card className="border-3 border-primary h-100">
                        <div className="d-flex justify-content-center mt-n4"><div className="text-primary bg-white p-2 fw-bold">Credentialers and Verifications</div></div>
                        <Card.Body className="pt-0">
                            <Card.Text>
                                <p>ABPN is not a primary source verification. If primary source verification is required, please visit <a className="link-primary" target="_blank" rel="noreferrer" href="https://www.abmssolutions.com/">ABMS Solutions | Premier Resource for Board Certification Verification</a>.</p>
                                <p>Find out more about <a className="link-primary" target="_blank" rel="noreferrer" href="https://abpn.org/check-physician-status/credentialers/">ABPN Certification Status Reporting</a>.</p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card className="border-3 border-info h-100">
                        <div className="d-flex justify-content-center mt-n4"><div className="text-info bg-white p-2 fw-bold">Patients and Public</div></div>
                        <Card.Body className="pt-0">
                            <Card.Text>
                                <p>Learn what it means for your physicians to achieve and maintain their certification.  Please see the <a href="https://abpn.org/check-physician-status/value-of-certification/" target="_blank">patients and public section on the ABPN website</a> for FAQs and detailed information about board certification by the ABPN.</p>
                                <p>What do you know about board-certified physicians? Please take the <a className="link-primary" target="_blank" rel="noreferrer" href="https://www.surveymonkey.com/r/D2ZR22Y">ABPN public survey</a> and let us know.</p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
}
